module.exports = __webpack_public_path__ + "img/heritage-store-new-product-launch-videography.2e9bd98b.jpg";